module.exports = __webpack_public_path__ + "img/btn_quanpin_ov.1706b958.png";